// Norwegian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `åpent til ${date}` : ''),
    },
    interview: {
      title: 'Svar videointervju',
      submit: 'Send svar og fullfør intervju',
      continueLater: 'Fortsette senere',
      startInterview: 'Start intervju',
      duplicateError: 'Du har allerede deltatt i dette intervjuet. Du har mottatt en e-post fra invitations@recright.com som inneholder en lenke som kan brukes til å fortsette intervjuet.',
      confirmSubmitHeader: 'Du har ikke svart på alle intervjuspørsmål',
      confirmSubmitContent: 'Har du virkelig ønsker å avslutte intervjuet?',
      confirmSubmitContentWarning: 'Etter dette, kan du ikke fullføre svarene.',
      submitInterviewHeader: 'Send inn intervjusvarene dine',
      submitInterviewContent: 'Er du sikker på at du vil sende inn intervjuet ditt?',
      confirmSubmitButton: 'Send svar og fullfør intervju',
      preview: 'Du kan forhåndsvise videospørsmålene her.',
      requiredQuestionsNotAnswered: 'Vennligst svar på alle obligatoriske spørsmål før du sender inn.',

      withdrawLink: 'Ikke interessert i denne stillingen lenger? Trekk deg fra prosessen her.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefonnummer',
      city: 'By',
      link: 'Kobling',
      legendBasicInfo: 'Grunnleggende informasjon',
      placeholderName: 'Oppgi navnet ditt',
      placeholderEmail: 'Oppgi e-posten din',
      placeholderPhone: 'Oppgi telefonen din',
      placeholderCity: 'Skriv inn ditt nåværende hjemsted',
      placeholderLink: 'Oppgi link',
      legendAttachments: 'Vedlegg',
      legendAdditionalFields: 'Tilleggsinformasjon',
      required: '* Feltene merket med stjerne er obligatoriske.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Lyd',
        video: 'Bilde',
        yes: 'Ja',
        no: 'Nei',
        supported: 'Støttet',
        quality: 'Kvalitet',
        header: 'Nettverkstilkobling og enhetstest',
        description: 'Vi skal nå kjøre en test, for å kontrollere at nettverkstilkoblingen og maskinvaren som trengs for å gjennomføre intervjuet (kamera og telefon) fungerer riktig. Når du blir spurt om det, la testen bruke både kamera og telefon, og pass på at kameraet ikke er tildekket. Testen kommer til å ta ca. 30 sekunder. Vi anbefaler at du snakker i løpet av maskinvaretesten.',
        inProgress: 'Test pågår …',
        networkTestResults: 'Resultat av nettverkstest',
        qualityTestResults: 'Resultat av kvalitetstest',
        testPassedQuality: 'Kvalitetstest bestått',
        testFailedQuality: 'Kvalitetstest mislykket',
        testPassedNetwork: 'Nettverkstest bestått',
        testFailedNetwork: 'Nettverkstest ikke bestått',
        startTest: 'Start testen',
        startInterview: 'Start intervjuet',
        testAgain: 'Test på nytt',
        confirmWarning: 'Når videointervjuet ditt begynner, flyttes du automatisk for å se det første intervjuspørsmålet. Etter at du har sett spørsmålet, flyttes du til forberedelse.',
        confirmTitle: 'Du er i ferd med å begynne intervjuet ditt',
        confirmText: 'Du har et øyeblikk på deg til å forberede svaret ditt før hver spørsmål. Etter forberedelse, har du en forhåndsbestemt periode hvor du kan besvare spørsmålet. Merk at du kan levere svaret med en gang du er klar, selv før den forhåndsbestemte svarperioden er ferdig.',
        confirmText2: 'Etter at du har levert svaret ditt, flyttes du videre til neste spørsmål, – helt til det ikke er flere spørsmål igjen.',
        confirmText3:
          'Merk at du etter å ha tatt opp svaret ditt på spørsmålet, har du et tidsvindu på 30 sekunder der du kan ta opp svaret ditt på nytt dersom nye opptak er tillatt for spørsmålet. Dersom du ikke starter et nytt opptak innen denne perioden på 30 sekunder, blir det gjeldende svaret ditt sendt inn automatisk, og du blir videreført til neste spørsmål.',
        goodLuck: 'Bare pust dypt, så går det bra. Lykke til!',
        qualityRating: {
          excellent: 'Strålende',
          good: 'Bra',
          fair: 'Greit',
          poor: 'Ikke bra',
          bad: 'Dårlig',
        },
      },
      questionAnswerView: {
        title: title => `Svar på intervjuet ${title}`,
        question: 'Spørsmål',
        submitAndNext: 'Send og neste',
        submitSuccess: 'Videoen ble levert!',
        skipText: 'Start opptak',
        stop: 'Stopp',
        submitAndFinish: 'Send inn og avslutt intervjuet',
        retake: 'Ta på nytt',
        take: 'Opptak',
        takesLeft: 'Gjenværende opptak',
        skipTextQuestion: 'Klar? Gå fremover',
        retakeConfirmTitle: 'Er du sikker på at du ønsker å ta opp svaret ditt på dette spørsmålet på nytt?',
        retakeConfirmSubmit: 'Ja, start nytt opptak',
        submitInfoForward: 'Sender inn det gjeldende svaret ditt automatisk og fortsetter om',
        submitInfoForward2: 'sekunder',
        nonAnswerableText: 'Denne meldingen krever ikke noe svar. Etter denne meldingen flyttes du direkte til neste spørsmål.',
        nonAnswerableVideo: 'Denne videoen krever ikke noe svar. Etter denne videoen flyttes du direkte til neste spørsmål.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Du har ${answerMinutes} minutter og ${answerSeconds} sekunder på deg til å svare på spørsmålet.`,
      },
      publisher: {
        toNextQuestion: timer => `Går til neste spørsmål om ${timer}`,
        recordingStarts: timer => `Opptaket begynner om ${timer}`,
      },
      errors: {
        tooManyConnections: 'Denne tilkoblingen ble lukket, fordi du allerede har en åpen tilkobling i en annen fane eller et annet vindu.',
        unsupportedBrowser: 'Dessverre støttes ikke denne handlingen av nettleseren din. Bruk en annen nettleser.',
        networkError: 'Ingen Internett-tilkobling.',
        reconnecting: 'Tilkoblingen ble avbrutt. Prøver å koble til på nytt.',
        generalError: 'Noe gikk galt. Oppdater siden og prøv på nytt.',
        allowMediaDevicesError: 'Denne handlingen kunne ikke innhente medieenheter (kamera eller mikrofon). Pass på at du har gitt nettleseren din tilgang til å bruke kamera og mikrofon.',
        noAvailableDevicesError: 'Vi fant ikke kamera eller mikrofon.',
        initPublisherError: 'Operasjonen mislyktes på grunn av en feil. Pass på at du har gitt nettleseren tillatelse til å bruke kameraet og mikrofonen, og at de ikke brukes av en annen applikasjon. Prøv deretter på nytt.',
      },
      browserInfo: {
        browserSupportTitle: 'Nettleserstøtte',
        supportedBrowsers: 'Denne testen og intervjuet støtter de nyeste versjonene av Chrome, Firefox, Safari og Edge.',
        mobileSupported: 'Nettlesere som støttes på mobiltelefon',
        android: 'Android: Google Chrome (nyeste versjon), Firefox (nyeste versjon:)',
        iOS: 'iOS: Safari (nyeste versjon)',
        latestVersion: 'Pass på at du bruker den nyeste versjonen av nettleseren. Dette for å passe på at alt fungerer som det skal.',
        freezeInstruction: 'Dersom videoopptaket ikke starter eller innspillingsskjermen forblir svart, må du oppdatere siden.',
        unsupportedOnIos: 'Det ser ut til at du bruker en nettleser som ikke støttes i iOS. Bruk Safari.',
        ieUnsupported: 'Det ser ut til at du bruker Internet Explorer. Dessverre er ikke Internett Explorer en støttet nettleser for denne testen eller intervjuet. Bruk en annen nettleser.',
        qualityTestNotSupported: 'Dessverre støttes ikke maskinvaretesting av nettleseren du bruker. Du kan fortsette til intervjuet uten å teste lyd- og bildekvalitet, eller bruke en annen nettleser.',
      },
      reconnectSuccess: 'Koblet til igjen!',
      continue: 'Fortsett',
    },

    withdraw: {
      title: 'Ikke interessert i denne stillingen lenger?',
      description: 'Trekk deg fra rekrutteringsprosessen.',
      buttonText: 'Trekk meg fra rekrutteringsprosessen.',
      thankYouTitle: 'Takk!',
      thankYouText: 'Du har nå informert rekruttørene om at du ikke lenger er interessert i stillingen.',
      confirm: 'Er du sikker på at du ønsker å trekke deg fra rekrutteringsprosessen? Etter at du har trukket deg, vil du ikke lenger kunne svare på dette eller intervjuer relatert til denne stillingen.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Send',
      continue: 'Fortsette',
      supportCenter: 'Recright Help Center',
      thankYou: 'Takk for videosvaret! Vi vil snart kontakte deg!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Takk for at du deltok i intervjuet!',
      reopenDescription: 'I tilfelle du lukket intervjuet ved et uhell, er det ikke noe å bekymre seg for. Du kan åpne intervjuet på nytt ved å klikke på knappen nedenfor!',
      reopenButtonText: 'Åpne intervju på nytt',
      description1: 'Supert, du har svart på alle spørsmålene og de har blitt sendt til mottaker.',
      descriptionsupport: mailto => `Hvis du har gjennomført dette intervjuet ved et uhell, kan du kontakte vår kundeservice ${mailto} og vi vil åpne intervjuet på nytt.`,
      descriptionfeedback: 'Din opplevelse er viktig for oss. Hvordan opplevde du å svare på et videointervju? Hvordan ville du forbedret tjenesten? Gi tilbakemelding her.',
      feedbackbutton: 'Gi oss tilbakemelding',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Personlig melding',
    },

    closed: {
      title: 'Intervjuet er avsluttet',
      description: 'Videointervjuet du ble invitert til er allerede avsluttet.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Ditt videointervju er nå lagret!',
      description: 'Når du ønsker å fortsette videointervjuet kan du bruke linken du fikk til din e-post. Hvis du allerede har spilt inn svar, vil de være på plass når du kommer tilbake! Lykke til med jobben jakten!',
      remember: 'Husk å sende svar til rekruttereren når du er ferdig med å svare på intervjuet.',
      deleteHistory: 'Hvis du gjør videointervjuet på en offentlig datamaskin, må du huske å tømme loggen. På den måten er intervjuet er trygg.',
    },
    unpublished: {
      title: 'Intervjuet har ikke åpnet ennå',
      publishTime: publishTime => `Intervjuet åpner ${publishTime}`,
    },
  },
}
